import React from 'react';
import { Container, Typography } from '@mui/material';
import Header from './components/Header';
import InputForm from './components/InputForm';
import ResultsDisplay from './components/ResultsDisplay';

function App() {
  return (
    <>
      <Header />
      <Container sx={{ mt: 3, mb: 3 }}>
        <Typography variant="body1" gutterBottom>
          Enter building and roof details to estimate energy savings, costs, and environmental impact.
        </Typography>
        <InputForm />
        <ResultsDisplay />
      </Container>
    </>
  );
}

export default App;
